import { appVersion } from "./version";

export const environment = {
  production: true,
  version: appVersion,//using environment/version.ts autogenerated in prebuild
  envname:    'app',
  showLang:   false,  
  website:    'http://www.onreference.com/',  
   
  apiurl:     'https://app.onreference.com/api/',
  //gdocsurl:   'https://script.google.com/macros/s/AKfycbzf3m6j8F9Q1DLhi5aJquZ2BqMvYH_vOqkBpZIWL0oqJrxHeuTII4HsO5T6FL4npkI/exec',
  gdocsurl:   'https://app.onreference.com/api/gas/proxy',
  clienturl:  'https://app.onreference.com/',

  //dev 
  //gdocsurl:   'https://script.google.com/macros/s/AKfycbycD9NPptQOis_TDK3hxU2Z9Dt-ZBANFT4w6Vz8wwv9ee4I-j62IScWPHpAAdEcaks/exec',
  //apiurl:     'https://dev.onreference.com/api/',
  //clienturl:  'https://dev.onreference.com/',//'https://h8v8q4n7.hostrycdn.com/',//'https://g7v3h9q5.hostrycdn.com/',

  languages: [
    { code: 'us',     label: 'English(US)'},
    //{ code: 'uk',     label: 'English(UK)'},
    //{ code: 'mr',     label: 'Marathi'},

    //{ code: 'hi',     label: 'Hindi'},    
    //{ code: 'ja',     label: 'Japanese'},        

    //{ code: 'zh-CN',  label: 'Chinese(Simplified)'},    
    //{ code: 'zh-TW',  label: 'Chinese(Traditional)'},        
    //{ code: 'es',     label: 'Español'},

    //{ code: 'fr',     label: 'Français'},
    //{ code: 'kn',     label: 'Kannada'},

    { code: 'ru',     label: 'Russian'}    
  ], 
  firebaseConfig: {
    apiKey: "AIzaSyAe3t-KKbGojV49ZEWSD3L0De_tX3OrY6g",
    authDomain: "appsscriptdev.firebaseapp.com",
    projectId: "appsscriptdev",
    storageBucket: "appsscriptdev.firebasestorage.app",
    messagingSenderId: "223514867157",
    appId: "1:223514867157:web:26b45a4814250d98f4f95c"
  } 
/*  firebaseConfig:{
    apiKey: "AIzaSyCeHsBZehV88AWzruBqdO4pu37HHbxzOn4",
    authDomain: "appsscriptprod.firebaseapp.com",
    projectId: "appsscriptprod",
    storageBucket: "appsscriptprod.firebasestorage.app",
    messagingSenderId: "770192263748",
    appId: "1:770192263748:web:4fc9f8d549f3d948808a11"
  }*/
};
